import { useEffect, useState } from "react";
import type { CommandCenterSnapshot } from "../types/login.types";
import {
  formatZonedYmdHms,
} from "../../../services/timeZoneService";
import styles from "./SystemHeader.module.css";

interface SystemHeaderProps {
  systemStatus: CommandCenterSnapshot["systemStatus"];
  className?: string;
  hideStatus?: boolean;
  hideClock?: boolean;
}

/** 예: 2026.08.04 17:23:00 KST */
export function formatKstDateTime(date: Date): string {
  return formatZonedYmdHms(date, "Asia/Seoul", "KST");
}

export { formatZonedYmdHm } from "../../../services/timeZoneService";

const STATUS_DOT: Record<CommandCenterSnapshot["systemStatus"], string> = {
  OPERATIONAL: styles.statusDot,
  DEGRADED: `${styles.statusDot} ${styles.statusDotDegraded}`,
  DOWN: `${styles.statusDot} ${styles.statusDotDown}`,
};

export function SystemHeader({
  systemStatus,
  className,
  hideStatus = false,
  hideClock = false,
}: SystemHeaderProps) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <header className={[styles.header, className].filter(Boolean).join(" ")}>
      {!hideStatus ? (
        <div className={styles.status}>
          <span className={STATUS_DOT[systemStatus]} aria-hidden />
          <span>SYSTEM STATUS · {systemStatus}</span>
        </div>
      ) : (
        <span />
      )}

      {!hideClock ? (
        <time className={styles.clock} dateTime={now.toISOString()}>
          {formatKstDateTime(now)}
        </time>
      ) : null}
    </header>
  );
}
